import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
    meta: { title: "登录" },
  },
  {
  path: "/",
    component: () => import("../views/Base.vue"),
    redirect: "/board",
    children: [
      {
        path: "/board",
        name: "board",
        component: () => import("../views/Board.vue"),
        meta: {
          title: "数据看板",
        },
      },

      {
        path: "/groups",
        name: "groups",
        component: () => import("../views/Groups.vue"),
        meta: {
          title: "重点人群",
        },
      },

      {
        path: "/library",
        name: "library",
        component: () => import("../views/Library.vue"),
        meta: {
          title: "企业岗位库",
        },
      },

      {
        path: "/region",
        name: "region",
        component: () => import("../views/Region.vue"),
        meta: {
          title: "区域人才库",
        },
      },

      {
        path: "/community",
        name: "community",
        component: () => import("../views/Community.vue"),
        meta: {
          title: "社区管理",
        },
      },

      {
        path: "/administrators",
        name: "administrators",
        component: () => import("../views/Administrators.vue"),
        meta: {
          title: "管理员设置",
        },
      },

      {
        path: "/ucenter",
        name: "ucenter",
        component: () => import("../views/Ucenter.vue"),
        meta: {
          title: "个人中心",
        },
      },
    ]
  },
  
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
